import ErrorLoggerService from "core/ErrorLoggerService";

import CUSTOMER_STATUSES from "../constants/CUSTOMER_STATUSES";

class DengageService {

  send = async(customerStatus: string, ...args: unknown[]): Promise<void> => {
    if (
      [ CUSTOMER_STATUSES.new, CUSTOMER_STATUSES.declined ].includes(
        customerStatus
      )
    ) {
      return;
    }

    try {
      (window as any).dengage?.(...args);
    }
    catch (error) {
      ErrorLoggerService("APP", "Dengage send", error);
    }
  };

  setNavigation = async(): Promise<void> => {
    try {
      (window as any).dengage?.("setNavigation");
    }
    catch (error) {
      ErrorLoggerService("APP", "Dengage setNavigation", error);
    }
  };
}

const Dengage = new DengageService();

export default Dengage;
